import styled from 'styled-components';
import { RadioGroupField, InputField } from 'lib/iterable-hook-form';
import { FormField } from 'ui/formField';
import { Modal, ModalFooter, ModalBody, ModalHeader } from 'ui/modal';
import {
  useModalsContext,
  Recipient,
  SEND_TEST_PUSH_FORM_FIELD_NAMES,
} from 'modules/sendingPlatforms/contexts';
import { ConnectedInputField } from 'modules/sendingPlatforms/components/Details/Shared/ConnectedInputField';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { useFormContext } from 'react-hook-form';
import noop from 'utils/noop';

const { MESSAGE, RECIPIENT, RECIPIENTS } = SEND_TEST_PUSH_FORM_FIELD_NAMES;

const recipientOptions = [
  {
    id: 'recipient-self',
    label: 'Yourself',
    value: Recipient.SELF,
  },
  {
    id: 'recipient-another',
    label: 'Another user',
    value: Recipient.ANOTHER,
  },
];

const RecipientsFormField = styled(FormField)`
  margin-left: 32px;
  && {
    margin-top: 8px;
  }
`;

export const SendTestPushModal = () => {
  const {
    watch,
    formState: { errors, isValid },
  } = useFormContext();
  const recipient = watch(RECIPIENT);
  const { hideModal } = useModalsContext();

  return (
    <Modal
      data-test="send-test-push-modal"
      id="send-test-push-modal"
      isModalOpen
      onClose={hideModal}
    >
      <ModalHeader>Send test push?</ModalHeader>
      <ModalBody>
        <FormField inputId={RECIPIENT} labelText="Recipient">
          <RadioGroupField name={RECIPIENT} options={recipientOptions} />
        </FormField>
        {recipient === Recipient.ANOTHER && (
          <RecipientsFormField
            inputId={RECIPIENTS}
            helpText="Enter up to 50 recipient user email addresses with each separated by a comma."
            errorText={(errors[RECIPIENTS]?.message as string) || ''}
            hasError={!!errors[RECIPIENTS]}
          >
            <InputField
              data-test="recipients-input"
              name={RECIPIENTS}
              placeholder="Example: recipient@companyname.com, recipient2@companyname.com"
            />
          </RecipientsFormField>
        )}
        <ConnectedInputField name={MESSAGE} labelText="Message" />
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          data-test="send-test-push-modal-confirm"
          onClick={noop}
          size={BUTTON_SIZES.LARGE}
          isDisabled={!isValid}
        >
          Send
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
